import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const CopyIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 22 22" sx={{ height: '22px', width: '22px', fill: 'transparent', ...sx }} {...props}>
      <g clipPath="url(#clip0_1976_1655)">
        <path
          d="M14.6668 7.33398V4.76732C14.6668 3.74055 14.6668 3.22717 14.467 2.835C14.2912 2.49004 14.0108 2.20957 13.6658 2.03381C13.2736 1.83398 12.7603 1.83398 11.7335 1.83398H4.76683C3.74007 1.83398 3.22668 1.83398 2.83451 2.03381C2.48955 2.20957 2.20909 2.49004 2.03332 2.835C1.8335 3.22717 1.8335 3.74055 1.8335 4.76732V11.734C1.8335 12.7607 1.8335 13.2741 2.03332 13.6663C2.20909 14.0113 2.48955 14.2917 2.83451 14.4675C3.22668 14.6673 3.74007 14.6673 4.76683 14.6673H7.3335M10.2668 20.1673H17.2335C18.2603 20.1673 18.7736 20.1673 19.1658 19.9675C19.5108 19.7917 19.7912 19.5113 19.967 19.1663C20.1668 18.7741 20.1668 18.2607 20.1668 17.234V10.2673C20.1668 9.24055 20.1668 8.72717 19.967 8.335C19.7912 7.99004 19.5108 7.70957 19.1658 7.53381C18.7736 7.33398 18.2603 7.33398 17.2335 7.33398H10.2668C9.24007 7.33398 8.72668 7.33398 8.33451 7.53381C7.98955 7.70957 7.70909 7.99004 7.53332 8.335C7.3335 8.72717 7.3335 9.24055 7.3335 10.2673V17.234C7.3335 18.2607 7.3335 18.7741 7.53332 19.1663C7.70909 19.5113 7.98955 19.7917 8.33451 19.9675C8.72668 20.1673 9.24007 20.1673 10.2668 20.1673Z"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1976_1655">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default CopyIcon;
